import errorReporter from '@app/errorReporter';
import { Page } from 'components';
import { AuthContext } from 'contexts';
import React, { useContext } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { featureEnabled } from 'utils';
import { Feature } from '@bb/automaton';
import { AnsweringSearchContextProvider } from './AnsweringSearchContext';
import AnsweringSearchLayout from './AnsweringSearchLayout';
import SearchBar from './Searchbar';
import { isTabType, TabType } from './types';
import { mlsStaffFeaturePageMap, viewContractsPage } from '../../constants';

export interface AnsweringSearchPageProps extends RouteComponentProps {
  tab: TabType;
}

const AnsweringSearchPage = (props: AnsweringSearchPageProps) => {
  const { tab } = props;
  const { auth } = useContext(AuthContext);
  const {
    auth: {
      org: { type },
    },
  } = useContext(AuthContext);
  if (!isTabType(tab)) {
    errorReporter.error('Invalid Anwering Search type');
  }

  if (type === 'mlsStaff') {
    let matchedPage = Object.entries(mlsStaffFeaturePageMap).find(([feature]) =>
      auth.org.features.includes(feature as Feature),
    );
    if (
      !featureEnabled('supraBillingApiFeature') &&
      matchedPage?.[1] === viewContractsPage
    ) {
      matchedPage = undefined;
    }
    const redirectToPath = matchedPage ? matchedPage[1] : '/feature-missing';
    return <Redirect to={redirectToPath} />;
  }

  if (type !== 'answering') {
    return <Redirect to="/listing/list/brokerage/0" />;
  }

  return (
    <AnsweringSearchContextProvider tab={tab} orgType={type}>
      <Page
        type="filled"
        title="Search"
        fillScreenHeight
        headerExtra={<SearchBar />}
      >
        <AnsweringSearchLayout />
      </Page>
    </AnsweringSearchContextProvider>
  );
};

export default AnsweringSearchPage;
